import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, ArrowLeft } from "lucide-react";
import mx from "@/locales/mx.json";

// Thank you page is Spanish-only regardless of app language.
const ThankYou = () => {
  const s = mx.thank_you;
  const brand = mx.brand.name;
  return (
    <div className="flex min-h-screen flex-col bg-[#F8FAFC] font-sans text-slate-800">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2">
            <span
              aria-hidden="true"
              className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-[#0B2545] font-serif text-lg font-bold text-white"
            >
              F
            </span>
            <span className="font-serif text-lg font-bold text-slate-900">
              {brand}
            </span>
          </Link>
        </div>
      </header>
      <main
        data-testid="thankyou-page"
        className="flex flex-1 items-center justify-center px-4 py-16 sm:px-6"
      >
        <div className="w-full max-w-2xl rounded-2xl border border-slate-200 bg-white p-8 shadow-sm sm:p-12">
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#16A34A]/10">
            <CheckCircle2 className="h-8 w-8 text-[#16A34A]" />
          </div>
          <h1
            data-testid="thankyou-title"
            className="mt-6 font-serif text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
          >
            {s.title}
          </h1>
          <p className="mt-3 text-lg text-slate-700">{s.subtitle}</p>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            {s.body}
          </p>

          <div className="mt-8 rounded-xl border border-slate-200 bg-[#F1F5F9] p-5">
            <h2 className="font-serif text-base font-semibold text-slate-900">
              {s.next_title}
            </h2>
            <ol className="mt-3 space-y-2 text-sm text-slate-700">
              <li data-testid="thankyou-next-1">1. {s.next_1}</li>
              <li data-testid="thankyou-next-2">2. {s.next_2}</li>
              <li data-testid="thankyou-next-3">3. {s.next_3}</li>
            </ol>
          </div>

          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="mt-8 inline-flex items-center gap-2 rounded-md bg-[#0B2545] px-5 py-3 text-sm font-semibold text-white hover:bg-[#133B6A]"
          >
            <ArrowLeft className="h-4 w-4" />
            {s.back_home}
          </Link>
        </div>
      </main>
    </div>
  );
};

export default ThankYou;
